import type { LinkInBio } from '@repo/lib';
import shouldShowCheckoutPageBranding from '../shouldShowCheckoutPageBranding';

type Seller = { subscriptionStatus?: string | null; showCheckoutPageBranding?: boolean | null };

export default function shouldShowLinkInBioBranding(
  seller: Seller | null | undefined,
  linkInBio: Pick<LinkInBio, 'showCheckoutPageBranding'> | null | undefined,
): boolean {
  const enabled = linkInBio?.showCheckoutPageBranding ?? undefined;
  return shouldShowCheckoutPageBranding(seller, {
    elements: { poweredByCheckoutPage: { enabled } },
  });
}
